import { Flex } from '@npco/zeller-design-system'

import { useSubscribeToAccounts } from 'hooks/banking'
import { useIsScrollActive } from 'hooks/useIsScrollActive'
import {
  DebitCardAccountStatus,
  DebitCardAccountType,
} from 'types/gql-global-types'
import { LoaderList } from 'components/LoaderList'

import { useAccountsListQuery } from './hooks/useAccountsListQuery/useAccountsListQuery'
import { useCacheNewAccount } from './hooks/useCacheNewAccount/useCacheNewAccount'
import { useEntitySavingsAccountProduct } from './hooks/useEntitySavingsAccountProduct/useEntitySavingsAccountProduct'
import { ListAccounts } from './ListAccounts/ListAccounts'
import { SavingsAccountBanner } from './SavingsAccountBanner/SavingsAccountBanner'

export const Accounts = () => {
  const { cacheNewAccount } = useCacheNewAccount()

  const { entity } = useEntitySavingsAccountProduct()
  const { debitCardAccounts, savingsAccounts, isLoadingAccounts, error } =
    useAccountsListQuery()

  useSubscribeToAccounts({
    onAccountUpdate: cacheNewAccount,
    skip: isLoadingAccounts || Boolean(error),
  })

  const { handleOnScroll } = useIsScrollActive()

  const isSavingsAccountActivated = savingsAccounts.some(
    (account) =>
      account.type === DebitCardAccountType.SAVINGS &&
      account.status === DebitCardAccountStatus.ACTIVE
  )

  const shouldShowBanner =
    !isSavingsAccountActivated && !isLoadingAccounts && entity

  return (
    <>
      {shouldShowBanner && <SavingsAccountBanner entity={entity} />}
      <Flex height="100%" minHeight={0} flexDirection="column">
        {isLoadingAccounts ? (
          <Flex height="100%" width="100%">
            <LoaderList />
          </Flex>
        ) : (
          <ListAccounts
            accounts={[...savingsAccounts, ...debitCardAccounts]}
            entity={entity}
            handleOnScroll={handleOnScroll}
          />
        )}
      </Flex>
    </>
  )
}
